import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 pb-0 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center field-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "A1005"),
  /*#__PURE__*/_createTextVNode(" Are you of Hispanic, Latino/a, or Spanish origin? (Check all that apply) ")
], -1 /* HOISTED */)
const _hoisted_4 = ["id", "disabled", "checked", "onChange"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "row py-3 g-0" }
const _hoisted_7 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center field-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "A1010"),
  /*#__PURE__*/_createTextVNode(" What is your race? (Check all that apply) ")
], -1 /* HOISTED */)
const _hoisted_9 = ["disabled", "id", "checked", "onChange"]
const _hoisted_10 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Race/Ethnicity",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.currentApplication)
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.ethnicity, (ethnicity) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${ethnicity.value}-${ethnicity.text}`
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(`form-check custom-checkbox ms-2 pb-1 ${
                                _ctx.isEthnicityDisabled(ethnicity.value) ? 'disabled-checkbox' : ''
                            }`)
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: `ethnicity-${ethnicity.value}`,
                  disabled: _ctx.isEthnicityDisabled(ethnicity.value),
                  checked: _ctx.referral.Demographics.EthnicitiesOnlyCollection.includes(ethnicity.value),
                  onChange: ($event: any) => (_ctx.handleEthnicity(ethnicity.value))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `ethnicity-${ethnicity.value}`
                }, [
                  _createElementVNode("small", null, _toDisplayString(ethnicity.text), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_5)
              ], 2 /* CLASS */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.race, (race) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${race.value}-${race.text}`
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(`form-check custom-checkbox pb-1 ms-2 ${
                                _ctx.isRaceDisabled(race.value) ? 'disabled-checkbox' : ''
                            }`)
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  disabled: _ctx.isRaceDisabled(race.value),
                  id: `race-${race.value}`,
                  checked: _ctx.referral.Demographics.RacesCollection.includes(race.value),
                  onChange: ($event: any) => (_ctx.handleRace(race.value))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `race-${race.value}`
                }, [
                  _createElementVNode("small", null, _toDisplayString(race.text), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_10)
              ], 2 /* CLASS */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}